<template>
  <span class="popup-link">
    <span v-html="getPreLinkText(paragraph)"></span>
    <a href="#/" v-b-popover.hover.html.focus="popoverConfig" title="">{{ getLinkText(paragraph) }}</a>
    <span v-if="content2 == null" v-html="getPostLinkText(paragraph)"></span>
    <span class="popup-link-content2" v-if="content2 != null">
      <span v-html="getPreLinkText(getSecondaryContent())"></span>
      <a href="#/" v-b-popover.hover.html.focus="popoverConfig2" title="">{{ getLinkText(getSecondaryContent()) }}</a>
      <span v-html="getPostLinkText(getSecondaryContent())"></span>
    </span>
  </span>
</template>

<script>
export default {
  name: "PopupLinker",
  props: {
    id: {
      type: String,
      default: "id-popup-linker",
    },
    paragraph: {
      type: String,
    },
    content: {
      type: String,
    },
    content2: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      // Text

      // Images

      // Variables
      popoverConfig: {
        customClass: "my-popover-class",
        content: this.getContent(),
      },
      popoverConfig2: {
        customClass: "my-popover-class",
        content: this.getContent2(),
      },
    };
  },
  mounted() {},
  computed: {},
  methods: {
    getContent() {
      return this.content;
    },
    getContent2() {
      return this.content2;
    },
    getPreLinkText(text) {
      var startTag = text.indexOf("<pop>");
      var endTag = text.indexOf("</pop>");
      //console.log("startTag:" + startTag + " endTag: " + endTag);
      if (startTag == -1 || endTag == -1) {
        return text;
      }
      var start = text.substring(0, startTag);
      //console.log("start :" + start);
      return start;
    },
    getLinkText(text) {
      var startTag = text.indexOf("<pop>");
      var endTag = text.indexOf("</pop>");
      if (startTag == -1 || endTag == -1) {
        return "";
      }
      var middle = text.substring(startTag + 5, endTag);
      //console.log("middle :" + middle);
      return middle;
    },
    getPostLinkText(text) {
      var startTag = text.indexOf("<pop>");
      var endTag = text.indexOf("</pop>");
      if (startTag == -1 || endTag == -1) {
        return "";
      }
      var end = text.substring(endTag);
      //console.log("end :" + end);
      return end;
    },
    getSecondaryContent() {
      var text = this.paragraph;
      var startTag = text.indexOf("<pop>");
      var endTag = text.indexOf("</pop>");
      if (startTag == -1 || endTag == -1) {
        return "";
      }
      var newStart = endTag + 6;
      var end = text.substring(newStart);
      //console.log("end :" + end);
      return end;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.popup-link {
}

.popup-link-content2 {
  margin-left: 0px;
}
/* unvisited link */
a:link {
  color: darkblue;
  text-decoration: none;
}

/* visited link */
a:visited {
  color: cornflowerblue;
}

/* mouse over link */
a:hover {
  color: cadetblue;
}

/* selected link */
a:active {
  color: darkslateblue;
}

.my-popover-class {
  background-color: #d7dfc8;
}

.popover .arrow {
  display: none;
}
</style>
